import { useState } from 'react';

/**
 * Open state for a floating element: controlled when `open` is given (with
 * `onOpenChange` reporting requests), otherwise kept here. Returns
 * [open, setOpen]. Floating UI's event and reason ('escape-key',
 * 'outside-press', 'focus-out'…) pass through to `onOpenChange`.
 */
export default function useOpenState(open, onOpenChange) {
    const [ownOpen, setOwnOpen] = useState(false);
    const controlled = open !== undefined;
    const setOpen = (next, event, reason) => {
        if (!controlled) setOwnOpen(next);
        onOpenChange?.(next, event, reason);
    };
    return [controlled ? open : ownOpen, setOpen];
}
